import { propTypes } from "@sanity/block-content-to-react";
import React, { useState } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './accordion.module.css';

function AccordionItem(props) {

    const [accordionOpen, setAccordionOpen] = useState(false);

    function toggleAccordion(id) {
        setAccordionOpen(!accordionOpen);
        $('*[data-acindex="'+id+'"] .accordionContent').slideToggle(200);
    }

    let accordionClass = styles.accordionItem + ' ' + ((accordionOpen) ? styles.accordionOpen : 'not-open');
    // let accordionClass = styles.accordionItem + ' ' + ((props.index == props.isOpen) ? styles.accordionOpen : 'not-open');

    let iconClass = 'fas fa-chevron-down';
    let contentClass = styles.accordionContent + ' accordionContent';

    return (
        <div className={accordionClass} data-acindex={props.index}>
            <div className={styles.accordionLabel}  onClick = {() => {toggleAccordion(props.index)} }>
                <h4>{props.item.title}</h4>
                <div className={styles.accordionIcon}>
                    <i className={iconClass}></i> 
                </div>
            </div>
            <div className={contentClass}>
                <PortableText blocks={props.item.content} />
            </div>
        </div>
    );
}
  
export default AccordionItem;